import {
	ReactElement,
	Ref,
	RefObject,
	useImperativeHandle,
	useRef
} from "react";
import {
	SearchInputForm,
	SearchInputFormHandle,
	SearchInputFormProps
} from "../SearchInputForm/SearchInputForm";
import { setTrackingId } from "client/Misc/utils";
import classNames from "classnames";
import styles from "./ActionListItem.module.less";

export type ActionListSearchHandle = {
	focusInput(): void;
	blurInput(): void;
};

export type ActionListSearchProps = Pick<
	SearchInputFormProps,
		| "value"
		| "onChange"
		| "trigger"
		| "placeholder"
		| "icon"
		| "trackingId"
		| "variant"
		| "onNavigateToResults"
		| "onKeyDown"
> & {
	ref?: Ref<ActionListSearchHandle>;
};

export const ActionListSearch = (props: ActionListSearchProps): ReactElement => {
	const {
		trackingId,
		ref,
		...otherProps
	} = props;

	const searchInputRef: RefObject<SearchInputFormHandle | null> = useRef<SearchInputFormHandle>(null);

	useImperativeHandle(
		ref,
		() => ({
			focusInput: () => {
				searchInputRef.current
					?.focusInput();
			},
			blurInput: () => {
				searchInputRef.current
					?.blurInput();
			}
		}),
		[]
	);

	return (
		<li
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			<div
				className={classNames(
					styles.contentHost,
					styles.contentHost_search
				)}
			>
				<SearchInputForm
					ref={searchInputRef}
					{...otherProps}
					hasMarginBottom={false}
				/>
			</div>
		</li>
	);
};
ActionListSearch.displayName = "ActionListSearch";
